<template>
    <transition name="toggleContentComponent">
        <article class="contentPopup" :class="{ nomenu: children.length == 0 }" v-if="ready">
            <div class="menu">

                <!-- parent -->
                <div class="parent level0">
                    <div class="menulink" @click="parentClicked" :class="{ active: currentData == properties }">
                        {{ properties.title }}</div>


                    <div class="children">
                        <!-- level1 children -->
                        <div v-for="level1item in children" class="child level1"
                            :class="{ hidden: level1item.data.hidden }">
                            <div class="menulink" @click="childClicked(level1item.data)"
                                :class="{ active: currentData == level1item.data }">
                                {{ level1item.data.title }}</div>


                            <div class="children">
                                <!-- level2 children -->
                                <div v-for="level2item in level1item.children" class="child level2"
                                    :class="{ hidden: level2item.data.hidden }">
                                    <div class="menulink" @click="childClicked(level2item.data)"
                                        :class="{ active: currentData == level2item.data }">
                                        {{ level2item.data.title }}</div>


                                    <div class="children">
                                        <!-- level3 children -->
                                        <div v-for="level3item in level2item.children" class="child level3">
                                            <div class="menulink" @click="childClicked(level3item.data)"
                                                :class="{ active: currentData == level3item.data }">
                                                {{ level3item.data.title }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="main">

                <template v-if="currentData.mainContent.text">
                    <h2 v-html="currentData.mainContent.header"></h2>
                    <div v-html="currentData.mainContent.text"></div>
                </template>

                <template v-if="currentData.mainContent.video">
                    <h2 v-html="currentData.mainContent.header"></h2>
                    <VideoPlayer :autoplay="false" :src="getSrc(currentData.mainContent.video.src)"></VideoPlayer>
                </template>

            </div>
            <div class="secondary">


                <div class="text-content" v-if="currentData.secondaryContent && currentData.secondaryContent.text">
                    <h2 v-html="currentData.secondaryContent.header"></h2>
                    <div v-html="currentData.secondaryContent.text"></div>

                </div>

                <div v-if="currentData.secondaryContent && currentData.secondaryContent.text" class="scrollfaders">
                    <div class="top"></div>
                    <div class="bottom"></div>
                </div>

                <div class="image-content" v-if="currentData.secondaryContent && currentData.secondaryContent.image">
                    <img :src="getSrc(currentData.secondaryContent.image.src)" />
                </div>

            </div>

            <div class="externalnav">
                <span v-if="currentData.externalLinks.length > 0" class="linklabel">eksterne links</span>
                <a v-for="link in currentData.externalLinks" :href="fixUrl(link.linkUrl)" _target="black"><img
                        src="@/assets/img/ui/link.png" />{{ link.title }}</a>

            </div>

            <button class="contentPopup__close" @click="closeComponent"></button>
        </article>
    </transition>
</template>
  
<script>

import VideoPlayer from '../_composable/VideoPlayer.vue'

export default {
    components: { VideoPlayer },
    props: [
        "properties",
        "children",
        "pageData",
        "slug"
    ],
    data() {
        return {
            ready: false,
            currentData: {},
            menulinkHeight: 50,
            menulinkSpace: 5
        }
    },
    created() {

    },
    mounted() {

        this.ready = true;

        // check query
        var defaultQuery = app.api.PageManager.getCurrentQuery();
        if (defaultQuery.child) {
            this.openChildFromQuery(defaultQuery.child)
        } else {
            this.setCurrent(this.properties);
        }

    },
    methods: {


        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },

        getSrc(src) {
            return app.api.Utils.getMediaPath(src);
        },
        isVideo(src) {
            return app.api.Utils.getMediaType(src) == 'video';
        },

        parentClicked() {
            // clear query
            app.api.PageManager.navigateToRoute(app.api.PageManager.getCurrentRoute());
        },

        childClicked(data) {
            // set query of child page 
            app.api.PageManager.navigateToRoute(app.api.PageManager.getCurrentRoute(), { "child": data.title })
        },


        async setCurrent(data, ancestors = []) {

            // remember current height of divs
            let childrenDivs = document.querySelectorAll('.children');
            childrenDivs.forEach((childrenDiv) => {
                let oldHeight = childrenDiv.clientHeight + 'px';
                childrenDiv.dataset.oldHeight = oldHeight;
            });


            // set current data
            this.currentData = data;

            //close all levels
            this.children.forEach(level1item => {
                level1item.data.hidden = true;
                if (level1item.children)
                    level1item.children.forEach(level2item => {
                        level2item.data.hidden = true;
                    });
            });

            // open active
            this.currentData.hidden = false;

            // and open ancestor (parent and granparents) levels
            ancestors.forEach(ancestor => {
                ancestor.data.hidden = false;
            });


            // meassuring children container heights for transition use
            // yes it's a bloody missery because of the multiple levels!

            await this.$nextTick();

            childrenDivs.forEach((childrenDiv) => {
                childrenDiv.style.maxHeight = 'none';
            });

            await this.$nextTick();

            childrenDivs.forEach((childrenDiv) => {
                let newHeight = childrenDiv.clientHeight + 10 + 'px';
                childrenDiv.dataset.newHeight = newHeight;
                let oldHeight = childrenDiv.dataset.oldHeight;
                childrenDiv.style.maxHeight = oldHeight;

            });

            await this.$nextTick();

            childrenDivs.forEach((childrenDiv) => {
                let height = childrenDiv.dataset.newHeight;
                childrenDiv.style.maxHeight = height;
            });

        },

        openChildFromQuery(title) {

            // keep track of ancestors while traversing
            var ancestors = [];

            for (var i = 0; i < this.children.length; i++) {
                ancestors = [];
                if (traverseDecendants.call(this, this.children[i], title)) {
                    break;
                };
            }

            function traverseDecendants(node, title) {
               
                if (node.data.title === title) {
                    node.data.hidden = false;
                    this.setCurrent(node.data, ancestors);
                    return (true);

                } else if (node.children) {
                    ancestors.push(node);
                    node.children.forEach(child => {
                        traverseDecendants.call(this, child, title);
                    });
                }
            }

        },

        fixUrl(url) {
            // Check if the URL starts with 'http://' or 'https://'
            if (!/^https?:\/\//i.test(url)) {
                // If not, add 'http://' to the beginning of the URL
                url = 'http://' + url;
            }
            return url;
        }
    },

    watch: {
        '$route.query': {
            handler(newQuery, oldQuery) {
                // Check if the query parameters have changed
                if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
                    // query has changed
                    if (newQuery.child) {
                        // find and goto child
                        this.openChildFromQuery(newQuery.child)
                    } else {
                        // goto root
                        this.setCurrent(this.properties);
                    }
                }
            },
            deep: true
        }
    }
};
</script>

  
<style lang="scss">
.contentPopup {

    width: 1720px;
    height: 750px;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-template-rows: 100% 60px;
    grid-template-areas: "menu main secondary" "link link link";
    font-size: 18px;
    line-height: 1.3em;


    &.nomenu {
        grid-template-columns: 1fr 1fr;
        grid-template-areas: "secondary main" "link link";

        .menu {
            display: none;
        }

    }

 

    .menu {
        grid-area: menu;
        padding-top: 10px;
        user-select: none;

        .menulink {
            position: relative;
            margin-right: -1px;
            display: flex;
            text-align: left;
            background-color: #fff;
            margin-bottom: 5px;
            padding: 0 20px;
            height: 50px;
            align-items: center;
            font-weight: bold;
            cursor: pointer;
            box-shadow: -10px 0px 10px -10px #000 inset;

            &.active {
                color: var(--main-color);
                box-shadow: none;
            }
        }

        .children {
            margin-left: 25px;
            opacity: 1;
            transition: all 0.3s cubic-bezier(0.6, 0.000, 0.4, 1.000);
        }


        .hidden {
            &>.children {
                max-height: 0px !important;
                opacity: 0;
            }

        }
    }

    .main {
        grid-area: main;
        background-color: #fff;
        padding: 60px;
        text-align: left;
        z-index: 4;
        overflow: auto;
        scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0);


        h2 {
            font-size: 30px;
            font-weight: bold;
            text-transform: uppercase;
            margin-bottom: 30px;
            line-height: 1.3em;
        }

    }

    .secondary {
        grid-area: secondary;
        background-color: #112545;
        padding: 0px;
        text-align: left;
        color: #fff;
        position: relative;


        &>.text-content {
            position: absolute;
            padding: 60px;
            overflow-y: auto;
            width: 100%;
            height: 100%;


            h2 {
                font-size: 30px;
                font-weight: bold;
                text-transform: uppercase;
                margin-bottom: 30px;
                line-height: 1.3em;
            }


        }

        &>.scrollfaders {
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 0;

            &>div {
                position: absolute;
                width: calc(100% - 10px);
                height: 80px;

                &.top {
                    top: -1px;
                    background: rgb(17, 37, 69);
                    background: linear-gradient(0deg, rgba(17, 37, 69, 0) 0%, rgba(17, 37, 69, 1) 90%);

                }

                &.bottom {
                    bottom: -1px;
                    background: rgb(17, 37, 69);
                    background: linear-gradient(180deg, rgba(17, 37, 69, 0) 0%, rgba(17, 37, 69, 1) 50%);
                }
            }


        }

        &>.image-content {

            width: 100%;
            height: 100%;

            &>img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }


        }


    }




    .contentPopup__close {
        position: absolute;
        right: -25px;
        top: -25px;
        height: 50px;
        width: 50px;
        border-radius: 50%;
        background: var(--main-color);
        background-image: url(@/assets/img/ui/close.svg);
        background-size: 30px;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 10;
    }

    .externalnav {
        grid-area: link;
        display: flex;
        justify-content: right;

        .linklabel {
            display: flex;
            align-items: flex-end;
            text-align: right;
            color: #fff;
            font-size: 24px;
            text-transform: uppercase;
            height: 64px;
            width: 133px;
            margin-right: 20px;
            line-height: 1em;
        }

        a {
            display: flex;
            flex-grow: 0;
            padding: 0 20px;
            align-items: center;
            justify-content: center;
            background-color: var(--main-color);
            color: #fff;
            font-size: 20px;
            text-transform: uppercase;

            img {
                margin-right: 10px;
            }
        }
    }
}
</style>